// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.button-scan[data-v-6785588a]:disabled, .button-scan[disabled][data-v-6785588a] {\n  background-color: #EDF0F0;\n  opacity: 0.5;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
